import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class NewsTopic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        handleMouseOver: PropTypes.func,
    };

    render() {
        const { content, handleMouseOver } = this.props;

        return (
            <div className={styles.topic}>
                {content.map((item, index) => {
                    if (item.type === 'more') {
                        return (
                            <span key={index} className={styles.more}>
                                <a href={item.url} target="_blank" rel={rel}>
                                    <img src={item.src} width={item.width} height={item.height} />
                                </a>
                            </span>
                        );
                    }

                    if (item.type === 'tag') {
                        return <span key={index} className={styles.tag} />;
                    }

                    return (
                        <React.Fragment key={index}>
                            {index === 0 ? '' : '·'}
                            <a
                                href={item.url}
                                target="_blank"
                                rel={rel}
                                data-index={index}
                                onMouseOver={handleMouseOver}>
                                {item.title}
                            </a>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

export default errorBoundary(NewsTopic);
